import React, { useEffect, useState } from "react";
import "./Loader.css"; // Import the CSS for the loader
import Logo from "../images/logo/logo.jpg";


const Loader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Automatically hide the loader after 5 seconds
    const timer = setTimeout(() => setIsVisible(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null; // Hide loader when the timer ends

  return (
    <div className="loader-overlay">
      <div className="loaders">
        <img /* style={{ width: '200px',
    height: 'auto',
    animation: 'dimEffect 2s infinite',}} */
          src={Logo} // Replace with your actual image
         // alt="Loading"
          className="loaders-image"
        />
        <h2 className="loading-text">Loading Website..</h2>
      </div>
    </div>
  );
};

export default Loader;